module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-z2-6992f6d85b9590e6b29bfd5718c92a45.svg";